import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class AccessorialRatesPercentOfTariffEditor extends React.Component {
    handlePersentChange() {
        return (e) => {
            const persent = Number(e.target.value);
            this.props.onChange('percent', persent);
            const description = `${persent}% of tariff rate`;
            this.props.onChange('description', description);
        };
    }

    validateValue(persent) {
        if (persent >= 0 && persent <= 100) {
            return '';
        }
        return 'error';
    }

    render() {
        const accessorialRate = this.props.accessorialRate || {};
        return (
          <Grid fluid>
            <Row className="show-grid">
              <Col xs={4}>
               <FormGroup>
                  <ControlLabel>{accessorialRate.name}</ControlLabel>
                  <FormControl
                    type="number"
                    defaultValue={accessorialRate.percent}
                    onChange={this.handlePersentChange()}
                    bsStyle={this.validateValue(accessorialRate.percent)}
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <div calssName="form-group" style={{ marginTop: 30 }}>
                  <label>% of tariff rate</label>
                </div>
              </Col>
            </Row>
          </Grid>
        );
    }
}

AccessorialRatesPercentOfTariffEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
